// extracted by mini-css-extract-plugin
export var card = "_u1-0";